import React from 'react'
import sAction from "sAction"
import PureComponent from '../../pure'
import PropTypes from 'prop-types'
class quickCreateActMenu extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      activeTab: props.activeTab,
    }

  }

  clickHandle(target) {
    this.props.clickFnc(target)
    this.setState({activeTab: target})
    this.setHeaderValues(target)
  }

  setHeaderValues(target) {
    let header = ""
    let color = ""
    let icon = ""

    switch (target) {
      case "detailMeeting":
        header = sAction.translate("LBL_TITLE_CREATE_NEW_MEETING", "Calendar")
        color = "MeetingsCalTitle"
        icon = "icon-Meetings"
        break
      case "detailCall":
        header = sAction.translate("LBL_TITLE_CREATE_NEW_CALL", "Calendar")
        color = "CallsCalTitle"
        icon = "icon-Calls"
        break
      case "detailTask":
        header = sAction.translate("LBL_TITLE_CREATE_NEW_TASK", "Calendar")
        color = "TasksCalTitle"
        icon = "icon-Tasks"
        break
    }

    sAction.dataSet(this.props.way + "/data/header", header)
    sAction.dataSet(this.props.way + "/data/color", color)
    sAction.dataSet(this.props.way + "/data/icon", icon)
  }

  componentDidMount() {
    this.setHeaderValues(this.state.activeTab)
  }

  render() {

    return (
      <nav className={'quickCreateNav' + (this.props.menuOpen === false ? " min" : "")}>
        <a className={"calQuicCreateTabMenuButton" + (this.state.activeTab === 'detailMeeting' ? ' activeTab' : '')}
           onClick={() => {
             this.clickHandle("detailMeeting")
           }}>
          <div className="calActMenuIcon icon-meetings"></div>
        </a>
        <a className={"calQuicCreateTabMenuButton" + (this.state.activeTab === 'detailCall' ? ' activeTab' : '')}
           onClick={() => {
             this.clickHandle("detailCall")
           }}>
          <div className="calActMenuIcon icon-calls"></div>
        </a>
        <a className={"calQuicCreateTabMenuButton" + (this.state.activeTab === 'detailTask' ? ' activeTab' : '')}
           onClick={() => {
             this.clickHandle("detailTask")
           }}>
          <div className="calActMenuIcon icon-tasks"></div>
        </a>
      </nav>
    )

  }

}

export default quickCreateActMenu

quickCreateActMenu.propTypes = {
  activeTab: PropTypes.string,
  clickFnc: PropTypes.func,
  menuOpen: PropTypes.bool,
  way: PropTypes.string,
}